import { Link } from 'react-router-dom';
import { products } from '../../utils/data';
import SectionHeader from '../common/SectionHeader';
import ProductCard from './ProductCard';

const FEATURED = products.slice(0, 6);

export default function ProductsPreview() {
  return (
    <section className="py-20 bg-[#f8faff]" id="products">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Our Portfolio"
          title="Featured Products"
          subtitle="From nutritional supplements to targeted therapeutics — our formulations are crafted for every health need."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {FEATURED.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/products"
            className="btn-primary text-base px-10 py-4"
          >
            View All 18 Products
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
